import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link, Redirect } from "react-router-dom";
import { config } from "../../constants";
import { toggleAlert } from "../../store/alertbox/alertboxAction";

//import CallApi from "../../util/CallApi";
//import { config } from "../../constants";
//import axios from "axios";

import { fetchProducts } from "../../store/products/productsAction";
import { addCartItem } from "../../store/orders/ordersAction";
const fpe = require("node-fpe");
const cipher = fpe({ password: config.appkey });
var numeral = require("numeral");
const locale = require("react-redux-i18n").I18n;

//const call = new CallApi();
class Products extends Component {
  state = {
    addCart: false
  };
  componentDidMount() {
    //console.log(this.props.project.project_id);
    // this.props.fetchProducts({ project_id: this.props.project.project_id });
    //const res = CallApi("GET", "/product/find/all");
    //console.log(res);

    // call.get("/product/find/all").then(res => {
    //   console.log(res);
    // });
  }

  clickOrder = (e, matId, device_id) => {
    if (!localStorage.getItem("access_token")) {
      //this.props.toggleAlert(`กรุณาล็อกอินเข้าสู่ระบบ`);
      e.preventDefault();
      const redirectLoginUri = encodeURI(
        config.loginRedirectUri +
        "param=" +
        cipher.encrypt(this.props.project.project_id)
      );
      const loginUrl = config.trueidUrl + "&redirect_uri=" + redirectLoginUri;
      window.location = loginUrl;
    }
    //check profile
    if (this.props.user.id_card === "" || this.props.user.id_card === null || this.props.user.id_card === undefined) {
      this.props.toggleAlert(locale.t("validateProfile"));
      //e.preventDefault();
      return false;
      // return <Redirect to="/register" />
    }

    if (this.props.project.order_status !== 'A') {
      e.preventDefault();
      this.props.toggleAlert(locale.t("orderExpire"));
      return false;
    } else {
      // check quota
      const quota =
        this.props.user.quota !== 0 || this.props.user.quota !== ""
          ? this.props.user.quota
          : this.props.project.quota;

      //console.log(this.props.orders.length);
      if (this.props.orders.length >= parseInt(quota)) {
        e.preventDefault();
        this.props.toggleAlert(locale.t("validateQuota"));
        return false;
      }

      // add new order item
      e.preventDefault();
      this.addCartItem(matId, device_id);
      //return <Redirect to="/cart" />
    }
  };

  async addCartItem(matId, device_id) {
    await this.props.addCartItem({
      project_id: this.props.user.project_id,
      customer_id: this.props.user.customer_id,
      device_id: device_id,
      product_id: matId
    });

    this.setState({
      addCart: true
    });
  }

  render() {
    if (this.state.addCart) {
      return <Redirect to="/cart" />;
    }
    const product = this.props.products.map(val => (
      <div className="section-produce">
        <div className="box-produce">
          <h3 className="text-ttl">{val.brand}</h3>
          <div className="produce-ber">
            <div className="row">
              <div className="col-md-5 col-sm-12">
                <div className="produce-ber-img">
                  <img
                    alt={val.device_model.model_image}
                    src={val.device_model.model_image}
                  />
                </div>
              </div>
              <div className="col-md-5 col-sm-12">
                <div className="produce-ber-text">
                  <h3>{val.device_model.name}</h3>
                  <p>{val.device_model.description}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="box-produce-list">
          <div className="row">
            {val.matcode.map(mat => (
              <div className="col-md-3">
                <div className="produce-list-inner">
                  <div className="produce-list-inner_text">
                    <div className="text-price">
                      <p>{numeral(mat.price).format("0,0.00")}</p>
                      <span>{locale.t("bathMonth")}</span><br />
                      {this.props.project.payment_type_id === 'pm001' ? <span style={{fontSize:'12px'}}>{locale.t("payVat")}</span> : ''}
                    </div>
                    <div className="text-color">
                      <p>
                        {locale.t("color")}: <span>{mat.color}</span>
                      </p>
                    </div>
                  </div>
                  <div className="produce-list-inner_btn">
                    <Link
                      to={
                        this.props.user.id_card === "" || this.props.user.id_card === null || this.props.user.id_card === undefined ? "/register" : "/cart"
                      }
                      onClick={e => this.clickOrder(e, mat.id, mat.device_id)}
                      className="btn btn-buy"
                    >
                      <i /> {locale.t("orderPrduct")}
                    </Link>
                    {/* <button className="btn btn-buy" onClick={this.clickOrder}>สั่งจองสินค้า</button> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div >
    ));
    return (
      <div className="col-sm-12 col-md-9 col-lg-10">
        {product}
        {/* <div className="section-produce">
          <p className="text-vat">{locale.t("conditionPrice")}</p>
        </div> */}
      </div>
    );
  }
}

Products.propTypes = {
  fetchProducts: PropTypes.func.isRequired,
  products: PropTypes.array.isRequired,
  isFetching: PropTypes.bool
};

const mapStateToProps = state => ({
  products: state.products.items,
  project: state.project.info,
  project_id: state.project.info.project_id,
  user: state.login.info,
  orders: state.orders.items,
  isFetching: state.products.isFetching,
  l: state.i18n.locale
});

export default connect(
  mapStateToProps,
  { fetchProducts, toggleAlert, addCartItem }
)(Products);
